/**
 * Gera um UUID v4. Usa `crypto.randomUUID()` quando disponível, mas cai num
 * fallback quando não está — `crypto.randomUUID` só existe em contexto seguro
 * (HTTPS ou localhost), então em deploys HTTP de rede interna ele é `undefined`
 * e chamá-lo direto quebraria a criação de ideias/mensagens silenciosamente.
 */
export function generateId(): string {
  const c = typeof crypto !== 'undefined' ? crypto : undefined
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID()
  }
  // Fallback baseado em getRandomValues (amplamente disponível)
  if (c && typeof c.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    c.getRandomValues(bytes)
    bytes[6] = (bytes[6] & 0x0f) | 0x40 // versão 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80 // variante
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
      .slice(6, 8)
      .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
  }
  // Último recurso (não-crypto): suficiente para IDs locais de UI
  return 'id-' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}
